import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=6e2f1738&scoped=true"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=6e2f1738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f1738",
  null
  
)

export default component.exports